import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Button,
  IconButton,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { db } from '../../firebase'; // adjust path
import {
  collection,
  doc,
  getDocs,
  setDoc,
  deleteDoc,
  onSnapshot,
} from 'firebase/firestore';
import { useAuth } from '../../context/AuthContext'; // adjust if needed

const TicketCart = () => {
  const { currentUser } = useAuth();
  const [cartItems, setCartItems] = useState([]);
  // alert(currentUser.uid);

  // Load cart from Firestore
  useEffect(() => {
    if (!currentUser) return;

    const cartRef = collection(db, 'users', currentUser.uid, 'ticketCart');

    const unsubscribe = onSnapshot(cartRef, (snapshot) => {
      const items = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setCartItems(items);
    });

    return () => unsubscribe();
  }, [currentUser]);

  const handleRemove = async (ticketType) => {
    try {
      const itemRef = doc(db, 'users', currentUser.uid, 'ticketCart', ticketType);
      await deleteDoc(itemRef);
    } catch (error) {
      console.error('Error removing cart item:', error);
    }
  };

  const total = cartItems.reduce(
    (sum, item) => sum + item.quantity * item.price,
    0
  );

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        Your Ticket Cart
      </Typography>

      {cartItems.length === 0 ? (
        <Typography>No tickets in cart.</Typography>
      ) : (
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Event</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Qty</TableCell>
              <TableCell>Price</TableCell>
              <TableCell>Total</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {cartItems.map((item) => (
              <TableRow key={item.id}>
                <TableCell>{item.eventName}</TableCell>
                <TableCell>{item.ticketType}</TableCell>
                <TableCell>{item.quantity}</TableCell>
                <TableCell>${item.price.toFixed(2)}</TableCell>
                <TableCell>${(item.quantity * item.price).toFixed(2)}</TableCell>
                <TableCell>
                  <IconButton onClick={() => handleRemove(item.ticketType)}>
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
            <TableRow>
              <TableCell colSpan={4} align="right">
                <strong>Total:</strong>
              </TableCell>
              <TableCell colSpan={2}>${total.toFixed(2)}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      )}

      {cartItems.length > 0 && (
        <Button variant="contained" color="primary" sx={{ mt: 2 }}>
          Proceed to Checkout
        </Button>
      )}
    </Box>
  );
};

export default TicketCart;
